// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__SRS7r","tableHeader":"Table_tableHeader__2SeW6","tableItemList":"Table_tableItemList__2SKAE"};